<template lang="pug">
img.preview-element.border-starmap(v-if="backgroundImage" :style="wrapStyle" :src="backgroundImage" )
div.preview-element.border-starmap(v-else :style="wrapStyle")
	slot
</template>

<script>
import {computed} from "vue";
import ParseSpecifications from "@/commons/ParseSpecifications";

export default {
	name: "BorderStarMapPreview",
	props: {

		selectedItems: {
			type: Object,
			default() {
				return {}
			}
		},

		dimensions: {
			type: Object,
			default() {
				return {}
			}
		},

		backgroundImage: {
			type: String,
			default: ''
		},

		svg: {
			type: String,
			default: ''
		}
	},

	setup(props) {
		const spec = computed(() => {
			return ParseSpecifications.parse(props.selectedItems.poster_size, props.dimensions)
		});

		const wrapStyle = computed(() => {

			return `
			width: ${spec.value.star_map_border.width}%;
			height: ${spec.value.star_map_border.height}%;
			top: ${spec.value.star_map_border.top}%;
			left: ${spec.value.star_map_border.left}%;
			bdackground-image: url(${props.backgroundImage});
			`;
		})

		return {
			spec,
			wrapStyle
		}
	}
}
</script>

<style lang="scss">
	.preview-element {
		&.border-starmap {
			position: absolute;
			text-align: center;
			width: 100%;
			height: 100%;
			background-size: contain;
			background-repeat: no-repeat;
			background-position: center center;
			margin: auto;

			svg {
				max-width: 100%;
				max-height: 100%;
			}
		}


	}
</style>
